import React, { useEffect, useState } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { useApiClient } from '../api/client';
import { useCurrentUser } from '../contexts/UserContext';
import { Card } from './ui';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApiClient();
  const { setUser } = useCurrentUser();
  const [userProvisioned, setUserProvisioned] = useState(false);

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      api.get('/me').then((userData) => {
        console.log('User loaded:', userData);
        setUser(userData as any);
        setUserProvisioned(true);
      }).catch((err) => {
        console.error('Failed to provision user:', err);
        setUserProvisioned(true);
      });
    }
  }, [isLoaded, isSignedIn]);

  if (!isLoaded) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: 'var(--space-4)',
        }}
      >
        <Card>
          <p style={{ color: 'var(--color-text-secondary)' }}>Loading...</p>
        </Card>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  if (!userProvisioned) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: 'var(--space-4)',
        }}
      >
        <Card>
          <p style={{ color: 'var(--color-text-secondary)' }}>Initializing...</p>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
